import { trackComponent } from './tracking'

const clickElements = document.querySelectorAll('[data-click-tracking]')

const trackClickEvent = (element: Element) => {
  const trackingProps = JSON.parse(element.getAttribute('data-click-tracking') ?? '')
  /* eslint-disable camelcase */
  const componentData = {
    component_category: trackingProps.component_category,
    component_id: trackingProps.component_id,
    component_name: trackingProps.component_name,
    contentful_name: trackingProps.contentful_name,
    contentful_variant: trackingProps.contentful_variant,
  }
  trackComponent('Dynamic Component Event', 'CTAButtonClicked', componentData, {
    ...trackingProps.additionalProps,
  })
}

Array.from(clickElements).forEach((element) => {
  element?.addEventListener('click', (_ele) => {
    trackClickEvent(element)
  })

  element?.addEventListener('auxclick', (_ele) => {
    trackClickEvent(element)
  })
})
